import {
  FiCompass,
  FiDroplet,
  FiLayers,
  FiMapPin,
  FiMaximize,
  FiPackage,
  FiPenTool,
  FiSettings,
  FiTag,
  FiTruck,
  FiWind,
} from "react-icons/fi";
import { getProductBySlug } from "../../data/products";
import { getPackagingOptions } from "../../data/packaging";

export const LAUNDRY_COLLECTION_PATH = "/products?category=sheets";
export const PACKAGING_PATH = "/products/laundry-detergent-sheets#product-laundry-detergent-sheets-detail-packaging";

export const aboutFaqs = [
  {
    question: "What is Klean Leaf?",
    answer: "Klean Leaf is a private label laundry detergent sheets manufacturer supporting custom formulas, packaging and brand development. We also support complementary laundry and home-care product formats.",
  },
  {
    question: "Who does Klean Leaf help?",
    answer: "We work with brands, wholesalers, distributors, refill shops, retailers, e-commerce sellers and laundry care companies launching or expanding a laundry detergent sheet product line.",
  },
  {
    question: "What is the minimum order quantity?",
    answer: "Retail-packed laundry sheet programs start at 1,000 package units per SKU. MOQ varies by formulation and packaging; PVA-free and custom-fragrance programs have separate requirements. Confirm your specification when requesting a quote.",
  },
  {
    question: "Can I customize the formula?",
    answer: "Yes. We help review formula requirements, sheet dimensions, texture, dissolution and cleaning performance. Available options and final specifications are confirmed through product discussion and sample review.",
  },
  {
    question: "What packaging options are available?",
    answer: "Laundry sheet options include mailer, perforated, drawer and kraft paper boxes, paper envelopes and resealable pouches. We provide dielines for artwork preparation. Availability depends on product configuration and order quantity.",
  },
  {
    question: "Do you offer samples?",
    answer: "Yes. We can ship sample sheets for formula, fragrance and product review before you confirm packaging and production. Our Columbus, Ohio team supports sample requests and communication.",
  },
  {
    question: "Can you customize fragrance?",
    answer: "Yes. We support fragrance-free sheets and multiple fragrance options. Review available fragrance samples with our team before confirming your direction, formula and applicable minimum order quantity.",
  },
  {
    question: "Where are products manufactured?",
    answer: "We manufacture our laundry detergent sheets at our own factory in China, from formulation and production to packing and shipment preparation. Our Columbus, Ohio team provides client communication and sample support.",
  },
  {
    question: "What support do private label clients receive?",
    answer: "Support covers product development, sampling, formula and fragrance selection, packaging review, dielines, artwork coordination, production follow-up, inspection and logistics coordination, from the initial brief through shipment planning.",
  },
];

export const stats = [
  { value: "300+", label: "Clients" },
  { value: "12+", label: "Years of experience" },
  { value: "1,000*", label: "Starting MOQ", note: "Retail packages per SKU" },
  { value: "45–60", label: "Days · First-order production*" },
];

export const processSteps = [
  { icon: FiCompass, title: "Product Development", copy: "Define your product, market and launch brief." },
  { icon: FiDroplet, title: "Formula & Fragrance", copy: "Review performance and scent directions." },
  { icon: FiPackage, title: "Samples", copy: "Compare sheets and confirm your specification." },
  { icon: FiPenTool, title: "Packaging & Artwork", copy: "Bring your brand to the final pack." },
  { icon: FiSettings, title: "Production & QC", copy: "Coordinate manufacturing and quality review." },
  { icon: FiTruck, title: "Shipping", copy: "Plan cartons, logistics and delivery." },
];

export const differences = [
  { icon: FiSettings, title: "Production Capability", copy: "Private label laundry sheets made in our own factory." },
  { icon: FiDroplet, title: "R&D Support", copy: "Formula, fragrance and dissolution review." },
  { icon: FiPackage, title: "Custom Packaging", copy: "Retail formats, dielines and branding support." },
  { icon: FiMapPin, title: "U.S.-Based Communication", copy: "Columbus, Ohio client and sample support." },
];

export const customizationOptions = [
  { icon: FiDroplet, title: "Formula" },
  { icon: FiWind, title: "Fragrance" },
  { icon: FiMaximize, title: "Sheet Size" },
  { icon: FiPackage, title: "Packaging" },
  { icon: FiTag, title: "Branding" },
  { icon: FiLayers, title: "Sheet Count" },
];

export const laundryProducts = [
  { slug: "laundry-detergent-sheets", label: "Laundry Detergent Sheets" },
  { slug: "3-in-1-enzyme-laundry-detergent-sheets", label: "3-in-1 Enzyme Sheets" },
  { slug: "5-in-1-solid-enzyme-laundry-detergent-sheets", label: "5-in-1 Solid Enzyme Sheets" },
  { slug: "baby-laundry-detergent-sheets-for-sensitive-skin", label: "Baby Laundry Sheets" },
  { slug: "pva-free-laundry-detergent-sheets", label: "PVA-Free Laundry Sheets" },
].map(({ slug, label }) => ({ product: getProductBySlug(slug), title: label }));

export const broaderProducts = [
  { slug: "laundry-detergent-tablets", title: "Tablets", to: "/products?category=tablets" },
  { slug: "laundry-pods", title: "Pods", to: "/products?category=pods" },
  { slug: "laundry-detergent-powder", title: "Powders", to: "/products?category=powders" },
  { slug: "floor-cleaning-sheets", title: "Cleaning Sheets", to: "/products?category=sheets" },
  { slug: "fragrance-booster-beads", title: "Fragrance Beads", to: "/products?category=fragrance-booster-beads" },
  { slug: "stain-removal-spray", title: "Stain Removal", to: "/products?category=stain-removal" },
].map(({ slug, title, to }) => ({ product: getProductBySlug(slug), title, to }));

export const packagingOptions = getPackagingOptions("KL-LDS-RG");
